<template>
  <s-wrapper>
    <s-header>
      <s-header-title>
        Escolha o profissional que irá atendê-lo
      </s-header-title>
      <icon
        :name="'cross-icon'"
        :width="14"
        :height="14"
        @click.native="closeDoctorModal"
      />
    </s-header>

    <s-summary>
      <s-summary-item>
        <span>Unidade</span>
        <h6>{{ selectedUnit.name }}</h6>
      </s-summary-item>

      <s-summary-item>
        <span>Especialidade médica</span>
        <h6>{{ selectedSpecialty.name }}</h6>
      </s-summary-item>
    </s-summary>

    <s-centered v-if="isLoading">
      <app-spinner />
    </s-centered>

    <s-doctors-list v-if="!isLoading && doctors.length">
      <s-doctors-list-item
        v-for="(doctor, index) in doctors"
        :key="doctor.id + index"
      >
        <s-doctor-card>
          <s-doctor-card-header>
            <div class="avatar avatar--sm">
              <img
                v-if="doctor.photo"
                :src="doctor.photo"
                :alt="doctor.name"
                loading="lazy"
                decoding="async"
              />
              <span v-else>
                {{ (doctor.name || "?").charAt(0).toUpperCase() }}
              </span>
            </div>
            <s-doctor-card-header-info>
              <h6>{{ doctor.name }}</h6>
              <small>
                {{ doctor.doctor_property.medical_specialty_name }},
                {{ doctor.doctor_property.council_name }},
                {{ doctor.doctor_property.council_number }}
              </small>
            </s-doctor-card-header-info>
          </s-doctor-card-header>

          <s-doctor-card-actions>
            <s-doctor-price class="mr-3">
              {{ doctor.doctor_property.price }}
            </s-doctor-price>
            <app-button
              variant="light"
              size="sm"
              block
              pill
              @click.native="selectDoctor(doctor)"
            >
              Escolher
            </app-button>
          </s-doctor-card-actions>
        </s-doctor-card>
      </s-doctors-list-item>
    </s-doctors-list>

    <s-footer v-if="!isLoading && doctors.length">
      <i><p>profissional(is) encontrado(s)</p></i>
    </s-footer>

    <s-empty-state v-if="!isLoading && !doctors.length">
      <h2>Nenhum profissional encontrado!</h2>
      <p>
        Escolha outra especialidade ou unidade para prosseguir com o
        agendamento.
      </p>
    </s-empty-state>
  </s-wrapper>
</template>

<script>
import {
  SCentered,
  SDoctorCard,
  SDoctorCardActions,
  SDoctorCardHeader,
  SDoctorCardHeaderInfo,
  SDoctorPrice,
  SDoctorsList,
  SDoctorsListItem,
  SEmptyState,
  SFooter,
  SHeader,
  SHeaderTitle,
  SSummary,
  SSummaryItem,
  SWrapper
} from "./styles";
import Icon from "../../CustomIcons.vue";
import AppButton from "../../AppButton";
import AppSpinner from "../../AppSpinner";

export default {
  name: "InstitutionDoctors",
  components: {
    Icon,
    AppSpinner,
    AppButton,
    SCentered,
    SDoctorCard,
    SDoctorCardActions,
    SDoctorCardHeader,
    SDoctorCardHeaderInfo,
    SDoctorPrice,
    SDoctorsList,
    SDoctorsListItem,
    SEmptyState,
    SFooter,
    SHeader,
    SHeaderTitle,
    SSummary,
    SSummaryItem,
    SWrapper
  },
  props: {
    unitId: {
      type: String,
      default: ""
    },
    specialtyId: {
      type: String,
      default: ""
    },
    closeDoctorsModal: {
      type: Function,
      default: () => undefined
    }
  },
  data() {
    return {
      doctors: []
    };
  },
  mounted() {
    this.fetchDoctors();
  },
  methods: {
    async fetchDoctors() {
      const response = await this.$store.dispatch(
        "doctor/fetchInstitutionDoctors",
        {
          medicalSpecialty: this.specialtyId,
          unitId: this.unitId
        }
      );
      this.doctors = response.data;
    },
    closeDoctorModal() {
      this.$emit("closeModal");
    },
    formatConsultationPrice,
    selectDoctor(doctor) {
      this.$emit("selectDoctor", doctor);
    }
  },
  computed: {
    selectedUnit() {
      const units = this.$store.getters["institutions/units"];
      const unitIdx = units.findIndex(unit => unit.id == this.unitId);
      return units[unitIdx];
    },
    selectedSpecialty() {
      const specialties = this.$store.getters["institutions/unitSpecialties"];
      const specialtyIdx = specialties.findIndex(
        specialty => specialty.id == this.specialtyId
      );
      return specialties[specialtyIdx];
    },
    isLoading() {
      return this.$store.getters["doctor/loading"];
    }
  }
};
</script>
